// https://parceljs.org/features/dependency-resolution/#glob-specifiers

export const asyncLanguages: Record<string, () => unknown> = {
	en: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/navigation-common-i18n-en" */ '../../../i18n/en'
		),
};
